import { object, string } from 'yup'

/**
 * Validation schema for the Login form
 */
export const loginFormValidationSchema = object().shape({
  email: string().email('Invalid email format').required('Email is required').trim(),
  password: string()
    .required('Password is required')
    .min(6, 'Password must contain at least 6 characters'),
})
